var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Typography, TileGroup, Tile, DrawerBody, LoadingButton, Button, DrawerFooter, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { buildDeliveryOptions } from '../../../utils/order-details/OrderDetailsUtils';
import { getWindow } from '../../../utils/general';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, useEditDeliveryAddressContext, } from '../../../hooks/useContexts';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { OmmAvailableDeliverySlots } from '../../../hooks/delivery-hooks';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { submitEditDeliveryAddress } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
export var EditDeliveryAddressDeliveryOptions = function (_a) {
    var _b;
    var closeDrawer = _a.closeDrawer, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, newDeliveryAddressDetails = _a.newDeliveryAddressDetails, isAddingNewAddress = _a.isAddingNewAddress, isDefaultValue = _a.isDefaultValue, isLoading = _a.isLoading, setIsChangeForm = _a.setIsChangeForm, setIsDeliveryOptions = _a.setIsDeliveryOptions, setIsDeliveryDetails = _a.setIsDeliveryDetails, setIsLoading = _a.setIsLoading, setIsExcludedAddress = _a.setIsExcludedAddress, setIsValidated = _a.setIsValidated, setUpdatedAddressData = _a.setUpdatedAddressData, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, setSelectedDeliveryOptionType = _a.setSelectedDeliveryOptionType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var _c = useState(''), selectedDeliveryOption = _c[0], setSelectedDeliveryOption = _c[1];
    var _d = useOrderContext(), fulfillmentOptionsResponse = _d.fulfillmentOptionsResponse, orderDetailsData = _d.orderDetailsData, setDeliveryAvailableSlotsApiError = _d.setDeliveryAvailableSlotsApiError, setShowDrawerError = _d.setShowDrawerError, setExcludedShipStateApiError = _d.setExcludedShipStateApiError;
    var _e = useEditDeliveryAddressContext(), setAvailableDeliverySlotsResponse = _e.setAvailableDeliverySlotsResponse, setAvailableDeliverySlots = _e.setAvailableDeliverySlots, setSelectedDateId = _e.setSelectedDateId;
    var _f = useFulfillmentGroupContext(), fulfillmentGroup = _f.fulfillmentGroup, fulfillmentGroupIndex = _f.fulfillmentGroupIndex;
    var _g = useThdCustomer() || {}, isLoggedIn = _g.isLoggedIn, isExchangeCustomer = _g.isExchangeCustomer;
    var deliveryOptions = buildDeliveryOptions(fulfillmentOptionsResponse);
    // Automatically select the first option after sorting
    useEffect(function () {
        if ((deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.length) > 0 && !selectedDeliveryOption) {
            setSelectedDeliveryOption(deliveryOptions[0].id);
        }
    }, [deliveryOptions, selectedDeliveryOption]);
    var handleContinue = function () {
        var _a, _b, _c, _d, _e, _f;
        setIsLoading(true);
        // Set the selected delivery type
        setSelectedDeliveryOptionType(selectedDeliveryOption);
        var fulfillmentTypeCode = ((_a = convertedFulfillmentTypes(selectedDeliveryOption)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
            undefined;
        var flowType = FLOW_TYPES.EDIT_DELIVERY_ADDRESS;
        // If BODFS was selected, call available-delivery-slots
        if (selectedDeliveryOption === FULFILLMENT_TYPE.BODFS) {
            var availableSlotsRequest = {
                flowType: flowType,
                orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                fulfillmentType: fulfillmentTypeCode || '',
                originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || undefined,
                newFulfillmentType: ((_c = convertedFulfillmentTypes(selectedDeliveryOption)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) ||
                    null,
                deliverySlotTypes: ['All Day'],
                et: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.et,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
                lineItems: ((_d = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _d === void 0 ? void 0 : _d.map(function (type) { return ({
                    lineId: type.lineId,
                    omsId: "".concat(type.secOmsId),
                    sku: "".concat(type.skuNumber),
                    price: type.unitPrice,
                    quantity: type.currentQuantity,
                }); })) || [],
                fulfillmentAddress: {
                    addressLine1: newDeliveryAddressDetails.addressLine1,
                    addressLine2: newDeliveryAddressDetails.addressLine2,
                    city: newDeliveryAddressDetails.city,
                    state: newDeliveryAddressDetails.state,
                    zipCode: newDeliveryAddressDetails.zipCode,
                    country: newDeliveryAddressDetails.country,
                },
            };
            OmmAvailableDeliverySlots(availableSlotsRequest, Boolean(isLoggedIn && !isExchangeCustomer), orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                .then(function (response) {
                var _a, _b;
                var data = response.data.data;
                setAvailableDeliverySlotsResponse(data);
                var sortedSlots = __spreadArray([], ((_a = data === null || data === void 0 ? void 0 : data.availableDeliverySlots) !== null && _a !== void 0 ? _a : []), true).sort(function (slotA, slotB) {
                    return DateTime.fromISO(slotA.startDateTime).toMillis() -
                        DateTime.fromISO(slotB.startDateTime).toMillis();
                });
                setSelectedDateId(((_b = sortedSlots === null || sortedSlots === void 0 ? void 0 : sortedSlots[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
                setAvailableDeliverySlots(sortedSlots);
                setIsDeliveryOptions(false);
                setIsChangeForm(false);
                setIsDeliveryDetails(true);
                setDeliveryAvailableSlotsApiError(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
                });
            })
                .catch(function () {
                setDeliveryAvailableSlotsApiError(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
                });
                closeDrawer();
            })
                .finally(function () {
                setIsLoading(false);
            });
            return;
        }
        // If STH was selected, call create-cart
        if (selectedDeliveryOption === FULFILLMENT_TYPE.STH) {
            var requestData = __assign(__assign({}, deliveryAddressCreateCartRequestData), { fulfillmentType: fulfillmentTypeCode, originalFulfillmentType: ((_e = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _e === void 0 ? void 0 : _e.toUpperCase()) || undefined, newFulfillmentType: ((_f = convertedFulfillmentTypes(selectedDeliveryOption)) === null || _f === void 0 ? void 0 : _f.toUpperCase()) ||
                    null });
            submitEditDeliveryAddress({
                deliveryAddress: {
                    addressLine1: newDeliveryAddressDetails.addressLine1,
                    addressLine2: newDeliveryAddressDetails.addressLine2,
                    city: newDeliveryAddressDetails.city,
                    state: newDeliveryAddressDetails.state,
                    zipCode: newDeliveryAddressDetails.zipCode,
                    country: newDeliveryAddressDetails.country,
                },
                firstNameValue: newDeliveryAddressDetails.firstName,
                lastNameValue: newDeliveryAddressDetails.lastName,
                phoneNumberValue: newDeliveryAddressDetails.phoneNumber || '',
                isDefaultValue: isDefaultValue,
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                deliveryAddressCreateCartRequestData: requestData,
                isAddingNewAddress: isAddingNewAddress,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                fulfillmentGroup: fulfillmentGroup,
                traceId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId,
                setIsChangeForm: setIsChangeForm,
                setIsDeliveryDetails: setIsDeliveryDetails,
                setIsLoading: setIsLoading,
                setShowDrawerError: setShowDrawerError,
                setExcludedShipStateApiError: setExcludedShipStateApiError,
                setIsExcludedAddress: setIsExcludedAddress,
                setIsValidated: setIsValidated,
                closeDrawer: closeDrawer,
                setUpdatedAddressData: setUpdatedAddressData,
                setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                flowType: flowType,
                setIsDeliveryOptions: setIsDeliveryOptions,
            });
        }
    };
    var handleChange = function (_event, id) {
        setSelectedDeliveryOption(id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(Typography, null, "Your delivery options have been updated based on your new delivery address."),
                React.createElement(TileGroup, { value: selectedDeliveryOption, onChange: handleChange, "aria-label": "rate", className: "sui-flex sui-flex-col sui-gap-5" }, deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.map(function (item) { return (React.createElement(Tile, { key: item.id, value: item.id, "aria-label": "delivery-address-tile", grow: true },
                    React.createElement("div", { className: "sui-w-full sui-p-3" },
                        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-items-center sui-min-w-0 sui-break-words" },
                            React.createElement("div", { className: "sui-flex-grow" },
                                React.createElement(Typography, { align: "left", weight: "bold", variant: "h5", height: "tight" }, item.title)),
                            React.createElement("div", null,
                                React.createElement(Typography, { weight: "bold", color: item.deliveryCost === 'FREE' ? 'success' : 'none' }, item.deliveryCost))),
                        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-1" },
                            (item === null || item === void 0 ? void 0 : item.dateLabel) && (React.createElement("div", { className: "sui-mt-1" },
                                React.createElement(Typography, { align: "left" },
                                    "Get it ",
                                    React.createElement("strong", null, item.dateLabel)))),
                            (item === null || item === void 0 ? void 0 : item.description) && (React.createElement(Typography, { align: "left" }, item.description)))))); })))),
        React.createElement(DrawerFooter, { id: "drawer-footer-z-index-fix", className: "sui-bottom-auto sui-p-4" },
            React.createElement("div", { className: "card-fix sui-pb-2" },
                React.createElement(LoadingButton, { "data-testid": "delivery-options-continue-button", onClick: handleContinue, loading: isLoading }, "Continue")),
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "secondary", onClick: function () { return closeDrawer(); } }, "Cancel")))));
};
